import { FeatureFlagsSettings, featureFlagsSettingSchema, PrincipalGroupLabelsSettings } from '@repo/shared/domain';
import { guardedClient as clientRequest } from '@repo/shared/helpers';
import request from '@nineeng/request';

export const getFeatureFlags = async (): Promise<FeatureFlagsSettings['settings']> => {
	try {
		const { body: featureFlagsSettings } = await clientRequest.get<typeof featureFlagsSettingSchema, FeatureFlagsSettings>(
			'/api/settings/feature-flags',
			{ schema: featureFlagsSettingSchema },
		);

		const featureFlags = featureFlagsSettings?.settings || {};

		// Return with defaults for any missing flags
		return {
			USES_RFID: featureFlags.USES_RFID || false,
			USES_RSID: featureFlags.USES_RSID || false,
			USES_RANDOM_CHECKS: featureFlags.USES_RANDOM_CHECKS || false,
			USES_EMERGENCY_MODULE: featureFlags.USES_EMERGENCY_MODULE || false,
			AUTO_CHECKIN: featureFlags.AUTO_CHECKIN || false,
			USES_RFID_ENC: featureFlags.USES_RFID_ENC || false,
			USES_MISTRAL: featureFlags.USES_MISTRAL || false,
			COMPANY_PORTAL_REMOTE_ACTIONS: featureFlags.COMPANY_PORTAL_REMOTE_ACTIONS || false,
			USES_COMPANY_API_CHECKS: featureFlags.USES_COMPANY_API_CHECKS || false,
			USES_SUBCONTRACTING: featureFlags.USES_SUBCONTRACTING || false,
			USES_TAGS: featureFlags.USES_TAGS || false,
			USES_PLAYIT: featureFlags.USES_PLAYIT || false,
			IS_ALHEEMBOUW: featureFlags.IS_ALHEEMBOUW || false,
			USES_WEBHOOKS: featureFlags.USES_WEBHOOKS || false,
			USES_SUPERVISOR: featureFlags.USES_SUPERVISOR || false,
			USES_EXTERNAL_ZONE_ACCESS: featureFlags.USES_EXTERNAL_ZONE_ACCESS || false,
			USES_OWNER_EMAIL_DOMAIN_CHECK: featureFlags.USES_OWNER_EMAIL_DOMAIN_CHECK || false,
		};
	} catch (error) {
		console.error('Failed to get feature flags from settings:', error);
		// Return defaults if settings are not available
		return {
			USES_RFID: false,
			USES_RSID: false,
			USES_RANDOM_CHECKS: false,
			USES_EMERGENCY_MODULE: false,
			AUTO_CHECKIN: false,
			USES_RFID_ENC: false,
			USES_MISTRAL: false,
			COMPANY_PORTAL_REMOTE_ACTIONS: false,
			USES_COMPANY_API_CHECKS: false,
			USES_SUBCONTRACTING: false,
			USES_TAGS: false,
			USES_PLAYIT: false,
			IS_ALHEEMBOUW: false,
			USES_WEBHOOKS: false,
			USES_SUPERVISOR: false,
			USES_EXTERNAL_ZONE_ACCESS: false,
			USES_OWNER_EMAIL_DOMAIN_CHECK: false,
		};
	}
};

export const getPrincipalGroupLabelsSettings = async (): Promise<PrincipalGroupLabelsSettings> => {
	const response = await request.get('/api/settings/principal-group-labels');
	return response.body as PrincipalGroupLabelsSettings;
};
